module.exports = __webpack_public_path__ + "static/media/mahika_valluri.1eb9fdf2.jpeg";